/**
 * Contact Section API service
 */

import { fetchStrapi } from './strapi';

export interface ContactSection {
  heading: string;
  description: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
  secondaryButtonIcon: string;
}

/**
 * Fetch contact section data from Strapi
 */
export async function fetchContactSection(): Promise<ContactSection | null> {
  try {
    const response = await fetchStrapi<any>(
      '/contact-section'
    );

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      heading: data.ueberschrift || '',
      description: data.beschreibung || '',
      primaryButtonText: data.primaerButtonText || '',
      primaryButtonLink: data.primaerButtonLink || '',
      secondaryButtonText: data.sekundaerButtonText || '',
      secondaryButtonLink: data.sekundaerButtonLink || '',
      secondaryButtonIcon: data.sekundaerButtonIcon || '',
    };
  } catch (error) {
    console.error('Error fetching contact section from Strapi:', error);
    return null;
  }
}


